import { AuthProvider } from "@/providers/auth.provider";
import { QueryProviders } from "@/providers/query.provider";
import { Outlet, createRootRoute } from "@tanstack/react-router";

const RootLayout = () => {
  return (
    <main
      className="flex min-h-screen w-full font-primary"
      role="main"
      aria-label="Main application layout"
    >
      <div className="flex min-h-screen w-full">
        <QueryProviders>
          <AuthProvider>
            <Outlet />
          </AuthProvider>
        </QueryProviders>
      </div>
    </main>
  );
};

// Root route configuration
export const Route = createRootRoute({
  component: RootLayout,
  // Add error boundary handling
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="p-4">
      <h1>Error</h1>
      <pre>{error.message}</pre>
    </div>
  ),
});
